import { useSelector } from "react-redux";

import {
  IMaintenanceWorkOrdersPageState,
  TOpenFilters,
  TAssignedFilters,
  TCompleteFilters,
  TClosedFilters,
  TCanceledFilters
} from "interfaces/MaintenanceWorkOrdersPageState";
import { hasSelectedFilters } from "components/Filters/helper";
import {
  MAX_SLIDER_FILTER_VALUE,
  MIN_SLIDER_FILTER_VALUE
} from "./WorkOrdersFiltersDialog/filterOptions";

interface IReduxStateFilters {
  openFilters: TOpenFilters;
  assignedFilters: TAssignedFilters;
  completeFilters: TCompleteFilters;
  closedFilters: TClosedFilters;
  canceledFilters: TCanceledFilters;
  hasSavedOpenFilters: boolean;
  hasSavedAssignedFilters: boolean;
  hasSavedCompleteFilters: boolean;
  hasSavedClosedFilters: boolean;
  hasSavedCanceledFilters: boolean;
}

export const useReduxStateFilters = (): IReduxStateFilters => {
  const {
    openFilters,
    assignedFilters,
    completeFilters,
    closedFilters,
    canceledFilters
  } = useSelector(
    (state: { maintenanceWorkOrdersPage: IMaintenanceWorkOrdersPageState }) => {
      return state.maintenanceWorkOrdersPage;
    }
  );

  const hasSavedOpenFilters = Boolean(
    openFilters &&
      hasSelectedFilters(
        Object.values(openFilters),
        MIN_SLIDER_FILTER_VALUE,
        MAX_SLIDER_FILTER_VALUE
      )
  );
  const hasSavedAssignedFilters = Boolean(
    assignedFilters &&
      hasSelectedFilters(
        Object.values(assignedFilters),
        MIN_SLIDER_FILTER_VALUE,
        MAX_SLIDER_FILTER_VALUE
      )
  );
  const hasSavedCompleteFilters = Boolean(
    completeFilters &&
      hasSelectedFilters(
        Object.values(completeFilters),
        MIN_SLIDER_FILTER_VALUE,
        MAX_SLIDER_FILTER_VALUE
      )
  );
  const hasSavedClosedFilters = Boolean(
    closedFilters &&
      hasSelectedFilters(
        Object.values(closedFilters),
        MIN_SLIDER_FILTER_VALUE,
        MAX_SLIDER_FILTER_VALUE
      )
  );
  const hasSavedCanceledFilters = Boolean(
    canceledFilters &&
      hasSelectedFilters(
        Object.values(canceledFilters),
        MIN_SLIDER_FILTER_VALUE,
        MAX_SLIDER_FILTER_VALUE
      )
  );

  return {
    openFilters,
    assignedFilters,
    completeFilters,
    closedFilters,
    canceledFilters,
    hasSavedOpenFilters,
    hasSavedAssignedFilters,
    hasSavedCompleteFilters,
    hasSavedClosedFilters,
    hasSavedCanceledFilters
  };
};
